<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    props: [
        'route_id'
    ],
}
</script>

<style>

</style>